import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-love",
  "use": "icon-icon-love-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-love\"><path d=\"M909.1072 162.0992a264.4992 264.4992 0 0 0-374.0672 0l-29.0816 29.0816L488.96 174.08a264.4992 264.4992 0 0 0-374.0672 374.1696L505.856 939.3152l12.0832-11.9808 391.168-391.0656a264.6016 264.6016 0 0 0 0-374.1696z\" p-id=\"5568\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol